import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {UserInfo} from "../service/Model/UserInfo";


@Component({
  selector: 'app-index-kraft',
  templateUrl: './app.index.kraft.html',
  styleUrls: ['./app.index.kraft.scss']
})
export class AppIndexKraft implements OnInit {

  @Input()
  version: string;


  userinfo : UserInfo;

  headerDescName: string;

  constructor(private router: Router) {
  }

  ngOnInit() {

    console.log("app.index.kraft - ngOnInit");

    this.router.events.subscribe(e => {
      switch (this.router.url) {
        case "/makpakAdmin":
          this.headerDescName = "Administration";
          break;
        case "/paketsuche":
          this.headerDescName = "Maklerpaketsuche";
          break;
        case "/maklerpaketKraft":
          this.headerDescName = "Maklerpaket";
          break;
        case "/massenberechnung":
          this.headerDescName = "Massenberechnung";
          break;
        case "/index-kraft":
          this.headerDescName = "MBP-Tool";
          break;
      }
    });
  }
}
